import { render, staticRenderFns } from "./registration_info_form.vue?vue&type=template&id=fca5dc52&"
import script from "./registration_info_form.vue?vue&type=script&lang=js&"
export * from "./registration_info_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports